import { createMuiTheme } from "@material-ui/core/styles";
import Montserrat from "../static/fonts/Montserrat/Montserrat-Light.ttf";

const montserrat = {
  fontFamily: "Montserrat",
  fontStyle: "normal",
  fontDisplay: "swap",
  fontWeight: 400,
  src: `
    local('Raleway'),
    local('Raleway-Regular'),
    url(${Montserrat}) format('woff2')
  `,
  unicodeRange:
    "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF",
};

export const lightTheme = createMuiTheme({
  // breakpoints: {
  //   values: {
  //     sm: "600",
  //   },
  // },
  palette: {
    primary: {
      main: "#000000",
    },
    secondary: {
      main: "#6C63FF",
    },
  },
  typography: {
    fontFamily: "Montserrat, Arial",
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "@font-face": [montserrat],
      },
    },
  },
});
